import React, { useEffect } from "react";
import { FaShieldAlt, FaBalanceScale, FaGavel, FaHandsHelping } from "react-icons/fa";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../Work/Work.css";

gsap.registerPlugin(ScrollTrigger);

const Work = () => {

    const sections = [
      {
        icon: <FaShieldAlt />,
        title: "Tax Planning",
        text: "Smart strategies for optimizing your tax liabilities effectively.",
      },
      {
        icon: <FaBalanceScale />,
        title: "Audit Services",
        text: "Professional insights into complex audit requirements.",
      },
      {
        icon: <FaGavel />,
        title: "Compliance Experts",
        text: "Experienced compliance support tailored to your business.",
      },
      {
        icon: <FaHandsHelping />,
        title: "Free Consultation",
        text: "Get your initial financial consultation completely free.",
      },
    ];
    


  useEffect(() => {
    gsap.utils.toArray(".section-item").forEach((item, index) => {
      const direction = index % 2 === 0 ? -150 : 150; // Alternate left or right
      const rotation = index % 2 === 0 ? 30 : -30; // Alternate rotation

      gsap.fromTo(
        item,
        {
          opacity: 0,
          scale: 0.9,
          x: direction,
          rotation: rotation,
        },
        {
          opacity: 1,
          scale: 1,
          x: 0, // Restore to original position
          rotation: 0,
          duration: 1, // Smooth animation
          ease: "power2.out", // Smooth easing
          scrollTrigger: {
            trigger: item,
            start: "top 80%", // Trigger animation slightly earlier
            end: "top 50%", // End animation sooner
            scrub: 0.5, // Smooth scrub timing
            toggleActions: "play reverse play reverse", // Smoothly play and reverse
          },
        }
      );
    });
  }, []);

  return (
    <div className="section-grid">
      {sections.map((section, index) => (
        <div key={index} className="section-item">
          <div className="icon-box">{section.icon}</div>
          <h3 className="w-h">{section.title}</h3>
          <p className="w-p">{section.text}</p>
        </div>
      ))}
    </div>
  );
};

export default Work;
